import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function FigureCard({ title, value, color = 'blue', icon }) {
  const bg = {
    blue: 'bg-blue-50 border-blue-200 text-blue-700',
    green: 'bg-green-50 border-green-200 text-green-700',
    yellow: 'bg-yellow-50 border-yellow-200 text-yellow-700',
    purple: 'bg-purple-50 border-purple-200 text-purple-700',
  }[color] || 'bg-gray-50 border-gray-200 text-gray-700';

  const textColor = bg.split(' ')[2];

  return (
    <div className={`p-4 border rounded-xl shadow-md flex items-center mb-2 space-x-3 bg-white `}>
      {icon && <FontAwesomeIcon icon={icon} className={`text-lg ${bg} border p-4 rounded-lg shadow-sm ${textColor}`} />}
      <div className="">
        <h4 className="text-sm font-semibold ">{title}</h4>
        <p className={`text-2xl font-bold ${textColor}`}>{value}</p>
      </div>
    
    </div>
  )
}

export default FigureCard

